import styled from 'styled-components'

export const HeaderHeight = '80px'
export const themeColor = '#f9bb19'

export const BreakingWidth = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px',
}

export const ColorPrimary = '#0078D4'

export const ColorFontPrimary = ColorPrimary
export const ColorFontNormal = '#4D4646'

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const FlexVerticalContainer = styled(FlexContainer)`
  flex-direction: column;
`

export const FlexHorizontalContainer = styled(FlexContainer)`
  flex-direction: row;
`
